module.exports = {
  localLink: "http://192.168.103.161:3001",
  globalLink: "https://web-back-banditik55.vercel.app",
  webTitle: `${window.location.host}`

  // apiLink: "https://dmitry.fun", // GLOBAL
}
